var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import UnlayerEditor from "./unlayer";
var ContentEditor = /** @class */ (function (_super) {
    __extends(ContentEditor, _super);
    function ContentEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.onLoad = function () {
            _this.isEditorReady = true;
            _this.editor.addEventListener('design:updated', function () { var _a, _b; return (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a); });
            _this.loadTemplate();
        };
        _this.loadTemplate = function () {
            var _a, _b;
            _this.timeout && clearTimeout(_this.timeout);
            _this.editor.loadDesign(((_a = _this.props.content) === null || _a === void 0 ? void 0 : _a.content) ? JSON.parse((_b = _this.props.content) === null || _b === void 0 ? void 0 : _b.content) : null);
            _this.timeout = setTimeout(_this.autosave, 2000);
        };
        // Export both values together so an explicit save never uses the previous timer tick.
        _this.exportContent = function () {
            if (!_this.isEditorReady || !_this.editor) {
                return Promise.reject(new Error('Content editor is not ready'));
            }
            return new Promise(function (resolve) {
                _this.editor.exportHtml(function (result) {
                    resolve(__assign(__assign({}, _this.props.content), { content: JSON.stringify(result.design), generatedHtmlCode: result.html }));
                });
            });
        };
        _this.autosave = function () {
            void _this.exportContent().then(function (content) {
                if (_this.isEditorReady)
                    _this.props.onSaved(content);
            }).catch(function (error) { return console.error('Failed to export editor content', error); });
            _this.timeout = setTimeout(_this.autosave, 1000);
        };
        _this.editor = null;
        _this.isEditorReady = false;
        _this.timeout = null;
        return _this;
    }
    ContentEditor.prototype.componentDidUpdate = function (previous) {
        // Unlayer reads its options once; a changed list goes through its own setter. Compared by content,
        // so a caller that rebuilds an equal list on every render sends nothing.
        if (this.isEditorReady && this.props.mergeTags
            && JSON.stringify(previous.mergeTags) !== JSON.stringify(this.props.mergeTags)) {
            this.editor.setMergeTags(this.props.mergeTags);
        }
    };
    ContentEditor.prototype.componentWillUnmount = function () {
        this.isEditorReady = false;
        this.timeout && clearTimeout(this.timeout);
    };
    //endregion
    //region UI
    ContentEditor.prototype.render = function () {
        var _this = this;
        return (_jsx(UnlayerEditor, { ref: function (editor) { return _this.editor = editor; }, options: __assign(__assign({ displayMode: this.props.displayMode }, (this.props.mergeTags && {
                mergeTags: this.props.mergeTags,
                mergeTagsConfig: { sort: false, delimiter: ['[[', ']]'] }
            })), (this.props.mergeTagsLabel && { translations: { 'en-US': { 'labels.merge_tags': this.props.mergeTagsLabel } } })), onReady: this.onLoad }));
    };
    return ContentEditor;
}(React.Component));
export default ContentEditor;
